import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import styles from './GroupUserTable.module.css'; // 원하는 스타일 적용
import { Today } from '@mui/icons-material';

const ExpirationUserTable = ({ users, onPrevPage, onNextPage, disablePrev, disableNext, pageNumber, totalCount, listSize, isMobileWindow, products }) => {  const [selected, setSelected] = useState([]);
  const [sortField, setSortField] = useState('userId');
  const [sortOrder, setSortOrder] = useState('asc');
  
  // 정렬 처리
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const sortedUsers = [...users].sort((a, b) => {
    let valA = a[sortField];
    let valB = b[sortField];
    // 날짜 비교
    if (sortField === "createdDate" || sortField === "lastConnectionDate") {
      valA = Number(valA) || 0;
      valB = Number(valB) || 0;
    }
    if (valA < valB) return sortOrder === "asc" ? -1 : 1;
    if (valA > valB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  // 체크박스 관련
  const isAllSelected = selected.length === users.length && users.length > 0;

  const handleSelectAll = () => {
    setSelected(isAllSelected ? [] : users.map(u => u.id));
  };

  const handleSelectRow = (id) => {
    setSelected(selected.includes(id)
      ? selected.filter(i => i !== id)
      : [...selected, id]);
  };

  const transStatusView = (status) => {
    switch(status){
      case 'active':
        return <span className={styles.badge} style={{backgroundColor: '#4CAF50'}}>할당됨</span>;
      case 'deactive':
        return <span className={styles.badge} style={{backgroundColor: '#9E9E9E'}}>미할당</span>;
      case 'expiration':
        return <span className={styles.badge} style={{backgroundColor: '#F44336'}}>만료</span>;
      default:
        return status;
    }
  };

  return (
    <div className={styles.tableSection}>
      <div className={styles.actionTopBar}>
        {/* 왼쪽: 검색 */}
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.idCol} onClick={() => handleSort('product')} style={{cursor:'pointer'}}>
              제품명 {sortField === 'product' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {!isMobileWindow && (
              <th className={styles.idCol} onClick={() => handleSort('licenseGrade')} style={{cursor:'pointer'}}>
                요금제 {sortField === 'plan' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            )}
            <th className={styles.idCol} onClick={() => handleSort('email')} style={{cursor:'pointer'}}>
              아이디 {sortField === 'email' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {/* <th className={styles.idCol} onClick={() => handleSort('password')} style={{cursor:'pointer'}}>
              비밀번호 {sortField === 'password' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th> */}
            {!isMobileWindow && (
              <th className={styles.idCol} onClick={() => handleSort('userName')} style={{cursor:'pointer'}}>
                사용자 {sortField === 'userName' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            )}
            <th className={styles.idCol} onClick={() => handleSort('endDate')} style={{cursor:'pointer'}}>
              잔여일 {sortField === 'endDate' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            
            {!isMobileWindow && (
              <th className={styles.idCol} onClick={() => handleSort('status')} style={{cursor:'pointer'}}>
                상태 {sortField === 'status' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {sortedUsers.map((user) => (
            // <tr key={user.id} className={styles.tableRow} onClick={() => handleRowClick(user.id)}  style={{ cursor: "pointer" }}>
            <tr key={user.id} className={styles.tableRow}>
              <td className={styles.idCol} style={{ cursor: "auto" }}>
                  {products?.[String(user.product)]?.name || '알 수 없음'}
              </td>
              {!isMobileWindow && (
                <td className={styles.idCol}>
                  {
                    products[user.product]?.plans.find(p => String(p.id) === String(user.plan))?.plan || '알 수 없음'
                  }
                  </td>
              )}
              <td className={styles.idCol}>{user.email}</td>
              {!isMobileWindow && (
                <td className={styles.idCol}>{user.userName}</td>
              )}
              <td className={styles.idCol}>
                {Math.max(0, Math.trunc((user.endDate - Date.now()) / (1000 * 3600 * 24)))}일
              </td>
              {!isMobileWindow && (
                <td className={styles.idCol}>{transStatusView(user.status)}</td>
              )}
            </tr>
          ))}
          {users.length === 0 && (
            <tr>
              {!isMobileWindow ?
                (<td colSpan={6} style={{textAlign: "center", color: "#888"}}>유저가 없습니다.</td>) :
                (<td colSpan={3} style={{textAlign: "center", color: "#888"}}>유저가 없습니다.</td>)
              }
            </tr>
          )}
        </tbody>
      </table>
      <div className={styles.actionBar} style={{marginTop: "8px"}}>
        <>
          {totalCount > 0 && (
            <p className={styles.text} >{pageNumber * listSize + 1} - {Math.min((pageNumber * listSize + 1) + listSize - 1, totalCount)} of {totalCount} </p>
          )}
          <button className={styles.addBtn} onClick={onPrevPage} disabled={disablePrev}>{"<"}</button>
          <button className={styles.addBtn} onClick={onNextPage} disabled={disableNext}>{">"}</button>
        </>
      </div>
    </div>
  );
};

export default ExpirationUserTable;
